import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  APPLICATION_GLOBAL_SLUG,
  CRYPTO_SECRET_KEY,
  paginate,
  PER_PAGE,
  SELECTED_EVENT_STORAGE,
  SOCKET_CHANNEL,
  SOCKET_URL,
  SOCKET_TRANSPORTS,
  trimTo,
  URLS,
} from "src/_config";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { toast } from "react-toastify";
import { useAppUserTokenSelector } from "src/_common/hooks/selectors/userSelector";
import StatusModal from "../modal/statusModal";
// import Pagination from 'react-js-pagination';
import useSocket from "use-socket.io-client";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function RodeoEventPage() {
  const eventApi = useEventApi();
  const history = useHistory();

  const [eventListData, setEventListData] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);
  const [isFetching, setIsFetching] = useState(false);
  const [isPageChange, setIsPageChange] = useState<boolean>(false);
  const [showStatusModal, setShowStatusModal] = useState<boolean>(false);
  const [appRedirectData, setAppRedirectData] = useState<any>();
  const userToken = useAppUserTokenSelector();

  const goToGameListingPage = (e: any, event: number) => {
    e.preventDefault();
    const eventId = cryptr.encrypt(event);
    localStorage.setItem(SELECTED_EVENT_STORAGE, eventId);
    history.push(`/event/${eventId}`);
    // if (userDetails) {
    //     history.push(`/event/${eventId}`)
    // } else {
    //     history.push(`${URLS.LOGIN}`)
    // }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!isFetching) return;
    fetchMoreListItems();
  }, [isFetching]);

  // Below function excute the scroll operation text show or hide
  function handleScroll() {
    if (window.innerHeight + document.documentElement.scrollTop !== document.documentElement.offsetHeight || isFetching)
      return;
    if (eventListData.length === total) return; //Disable scrolling state if total event data is equal to total data
    setIsFetching(true);
  }

  //Get event List
  const getEventList = () => {
    var params = {
      page: page,
      perPage: PER_PAGE,
    };

    eventApi.callGetEventList(
      params,
      (message: string, resp: any) => {
        if (resp && resp.list && resp.list.length) {
          setEventListData((prevState) => [...prevState, ...paginate(resp.list, PER_PAGE, page)]);
          setTotal(resp.list.length ? resp.list.length : 0);
          setPage(page + 1);
          setIsFetching(false);
        } else {
          setEventListData((prevState) => [...prevState]);
          setIsFetching(false);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  //On page scroll load more data
  // Event api call once again
  const fetchMoreListItems = () => {
    // setTimeout(() => {
    getEventList();
    // }, 2000);
  };

  //First Time call When component is load
  useEffect(() => {
    getEventList();
  }, []);

  const goToLeaderBoardPage = () => {
    history.push({
      pathname: URLS.EVENT.LEADERBOARD,
      state: { id: "" },
    });
  };

  const onStatusModalClose = () => {
    setShowStatusModal(false);
  };

  const onStatusModalSuccess = () => {
    if (appRedirectData) {
      setShowStatusModal(false);
      let link = appRedirectData.game_info.pwa_link;
      if (link) {
        setTimeout(() => {
          window.open(
            link +
              (appRedirectData?.rodeo_event_id && userToken
                ? `#token=${cryptr.encrypt(appRedirectData.rodeo_event_id)}&userToken=${userToken}`
                : appRedirectData?.rodeo_event_id
                ? `#token=${cryptr.encrypt(appRedirectData.rodeo_event_id)}`
                : userToken
                ? `#userToken=${userToken}`
                : ""),
            "_blank"
          );
        }, 500);
      }
    }
  };

  const fetchMoreData = () => {
    setIsFetching(true);
  };

  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
    withCredentials: true,
    transports: SOCKET_TRANSPORTS,
    upgrade: true,        // Enable transport upgrades (polling -> websocket)
    rememberUpgrade: true, // Remember successful upgrades for faster reconnection
  });

  useEffect(() => {
    socket.connect();

    socket.on(SOCKET_CHANNEL.APP_REDIRECT, (data: any) => {
      if (data.game_info.slug != APPLICATION_GLOBAL_SLUG) {
        console.log({ data });
        setShowStatusModal(true);
        setAppRedirectData(data);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <React.Fragment>

      <div className="logo-wrap">
        <img src="/images/logo.png" alt="Logo" className="medium-logo" />
      </div>

      {/* <div className="page-title-outer">
                <h2 className="page-title text-center justify-content-center led-box" onClick={() => {
                    goToLeaderBoardPage();
                    }}
                > */}
      {/* <Link to={URLS.EVENT.LEADERBOARD} className="back-history"> */}
      {/* Leaderboard */}
      {/* </Link> */}
      {/* <div className='led-box-icon'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
                        <path d="M19.1781 5.80839C19.4881 5.73382 19.8106 5.74999 20.1277 5.7491C22.1951 5.75269 24.2615 5.7482 26.3288 5.75089C27.0906 5.73203 27.8265 6.21808 28.1176 6.91976C28.3206 7.37167 28.2649 7.8766 28.2712 8.35726C28.2712 18.3308 28.2712 28.3044 28.2712 38.2779C28.2945 39.029 27.839 39.7666 27.1508 40.073C26.7277 40.2832 26.2434 40.2509 25.7852 40.2509C23.8985 40.25 22.0127 40.2491 20.1269 40.2509C19.6974 40.2545 19.2464 40.2698 18.8511 40.0748C18.1656 39.7675 17.7038 39.0344 17.7289 38.2824C17.7289 28.0941 17.7289 17.9068 17.7289 7.71937C17.6939 6.84609 18.3291 6.01054 19.1781 5.80839Z" fill="#67084E"/>
                        <path d="M5.24781 17.3174C5.47062 17.2563 5.70332 17.25 5.93332 17.2482C8.11742 17.2545 10.3024 17.2446 12.4874 17.2527C13.4874 17.2419 14.3804 18.1341 14.3714 19.1331C14.3768 25.5435 14.3777 31.9547 14.3714 38.3651C14.3804 39.3614 13.4919 40.2518 12.4955 40.2464C10.2467 40.2536 7.99703 40.25 5.74824 40.2482C4.7384 40.2707 3.82469 39.3749 3.83637 38.3633C3.83008 31.9853 3.83547 25.6073 3.83277 19.2293C3.79414 18.365 4.41137 17.5348 5.24781 17.3174Z" fill="#67084E"/>
                        <path d="M33.0042 21.1609C33.3743 21.054 33.7633 21.0863 34.1434 21.0827C36.0885 21.0827 38.0345 21.0854 39.9796 21.0809C40.3318 21.0774 40.6966 21.0926 41.0209 21.2472C41.7028 21.5409 42.1736 22.2579 42.1646 23.0018C42.1673 28.122 42.17 33.2422 42.1637 38.3624C42.1727 39.3722 41.2644 40.268 40.2555 40.2482C38.0372 40.2527 35.819 40.2491 33.6007 40.25C32.8326 40.2779 32.0833 39.7999 31.7841 39.0928C31.5981 38.6984 31.6233 38.251 31.6242 37.826C31.6278 32.8837 31.6224 27.9405 31.6269 22.9973C31.6134 22.1681 32.2091 21.3846 33.0042 21.1609Z" fill="#67084E"/>
                        </svg>
                    </div>
                </h2>
            </div> */}
      <div className="event-list-wrapper">
        <div className="event-list">
          {eventListData && eventListData.length ? (
            eventListData.map((event: any) => (
                              <Link to="#" key={event.id} onClick={(e) => goToGameListingPage(e, event.id)}>
                <img src={event && event.avatar ? event.avatar.original : "/images/no-image.png"} alt={event.title} />
              </Link>
            ))
          ) : (
            <div className="no-text text-white text-center">No events available</div>
          )}
        </div>
      </div>
      {/* {
                isFetching &&
                <div style={{ color: '#fce006' }}>
                    <p>Loading more events. Please wait... </p>
                </div>
            } */}
      {/* <UpcomingRodeoEventComponent /> */}
      {showStatusModal && appRedirectData && (
        <StatusModal
          shouldShow={showStatusModal}
          onClose={onStatusModalClose}
          onSuccess={onStatusModalSuccess}
          message={appRedirectData?.message}
          type={2}
        />
      )}

      {eventListData && !(eventListData?.length === total) ? (
        <div className="d-flex justify-content-center load-more-btn-panel">
          <button className="load-more-btn" onClick={fetchMoreData}>
            Load More
          </button>
        </div>
      ) : null}
      {/* <div className='footer-panel'>
                <p>© Copyright 2023 Inside Rodeo</p>
            </div> */}
    </React.Fragment>
  );
}
